import apiFarms from "../config/api_farms";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

export function findFarmDayScaleTreatmentParameterData(payload) {
  const { groupId, farmId } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/day/scale/parameters`,
    getHeaders(false, null)
  );
}

export function saveFarmDayScaleTreatmentParameterData(payload) {
  const { groupId, farmId, body } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/day/scale/parameters`,
    body,
    getHeaders(false, null)
  );
}
